// @flow
import React from 'react';
import { formatDate, slugify } from 'Utils/index';
import { Container, Row, Col } from 'Components/Grid';
import DefaultPage from 'Containers/DefaultPage';
import ErrorPage from 'Containers/ErrorPage';
import HeroHeader from 'Components/HeroHeader';
import NewsModel from 'Stores/NewsModel';
import FollowUp from 'Components/FollowUp';
import RichText from 'Components/RichText';
import Gallery from 'Components/Gallery';
import { getGivenBackground } from 'Utils/getColor/index';
import ConsumptionData from 'Components/ConsumptionData';

type Props = {
  news: {},
};

export default class NewsDetails extends React.Component<Props> {
  render() {
    const { news: newsProp } = this.props;

    if (!newsProp) {
      return <ErrorPage />;
    }

    const news = new NewsModel(newsProp);

    let nextLink = '';
    let nextPreview = '';
    let prevLink = '';
    let prevPreview = '';

    if (news) {
      if (news.next) {
        nextLink = `/ueber-uns/autohaus/events-und-news/${news.next.id}-${slugify(
          news.next.title
        )}/`;
        nextPreview = news.next.title;
      }

      if (news.prev) {
        prevLink = `/ueber-uns/autohaus/events-und-news/${news.prev.id}-${slugify(
          news.prev.title
        )}/`;
        prevPreview = news.prev.title;
      }
    }

    return (
      <DefaultPage background={getGivenBackground('white')}>
        <HeroHeader
          small
          image={news.image}
          title={news.title}
          subtitle={
            news.type === 'event'
              ? `${news.type} ${formatDate(news.startDate)} - ${formatDate(news.endDate)}`
              : `${news.type} ${formatDate(news.datePublished)}`
          }
          backlink="/ueber-uns/autohaus/events-und-news/"
        />
        <Container>
          <Row align="center">
            <Col cols={12} l={8}>
              <RichText content={news.text} />
            </Col>
          </Row>
        </Container>

        {news.gallery && <Gallery images={news.gallery} />}

        {newsProp.consumptionText && (
          <ConsumptionData consumptionText={[newsProp.consumptionText]} />
        )}

        <FollowUp
          prevLabel="Vorheriger Artikel"
          nextLabel="Nächster Artikel"
          prevLink={prevLink}
          nextLink={nextLink}
          prevPreview={prevPreview}
          nextPreview={nextPreview}
        />
      </DefaultPage>
    );
  }
}
